import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSizeSLarge = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 33.195 44.26",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "S-M_Banner",
		transform: "translate(6507 21323)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_182",
			"data-name": "Group 182",
			transform: "translate(-6507 -21323)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_209",
				"data-name": "Path 209",
				d: "M32.507,1.844a1.742,1.742,0,0,1,1.844,1.844V40.572a1.742,1.742,0,0,1-1.844,1.844H6.688a1.742,1.742,0,0,1-1.844-1.844V3.688A1.742,1.742,0,0,1,6.688,1.844H32.507m0-1.844H6.688A3.7,3.7,0,0,0,3,3.688V40.572A3.7,3.7,0,0,0,6.688,44.26H32.507A3.7,3.7,0,0,0,36.2,40.572V3.688A3.7,3.7,0,0,0,32.507,0Z",
				transform: "translate(-3)"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2713",
			"data-name": "Path 2713",
			d: "M8.453,2.909a1.525,1.525,0,0,0-.594-1.293A7.8,7.8,0,0,0,5.719.665,15.167,15.167,0,0,1,3.273-.32,4,4,0,0,1,.816-3.9a3.483,3.483,0,0,1,.659-2.085A4.3,4.3,0,0,1,3.367-7.413a7.121,7.121,0,0,1,2.769-.515,6.482,6.482,0,0,1,2.754.56,4.385,4.385,0,0,1,1.877,1.58,4.134,4.134,0,0,1,.669,2.318H8.463a1.945,1.945,0,0,0-.624-1.54,2.565,2.565,0,0,0-1.753-.55A2.741,2.741,0,0,0,4.392-5.1a1.453,1.453,0,0,0-.6,1.213A1.391,1.391,0,0,0,4.5-2.708a8,8,0,0,0,2.085.891A9.009,9.009,0,0,1,10.276.076a3.768,3.768,0,0,1,1.159,2.813,3.471,3.471,0,0,1-1.416,2.937A6.2,6.2,0,0,1,6.2,6.891a7.364,7.364,0,0,1-3.031-.609A4.8,4.8,0,0,1,1.089,4.612,4.274,4.274,0,0,1,.371,2.156H3.352q0,2.387,2.853,2.387a2.775,2.775,0,0,0,1.654-.431A1.4,1.4,0,0,0,8.453,2.909Z",
			transform: "translate(-6496.522 -21300.289)"
		})]
	})
});
export default SvgSizeSLarge;
